import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';

import { NotesDrawerLoader } from './components/NotesDrawerLoader';
import { NotesDrawerContent } from './components/NotesDrawerContent';
import { useNotesDrawerContact } from './hooks/useNotesDrawerContact';

export const NotesDrawer = ({ isOpen, contactId, listInfo, onClose }) => {
  const { contact, isFetching } = useNotesDrawerContact(contactId, listInfo);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <Flex
      data-testid="notes-drawer"
      height="100%"
      width="100%"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 100,
      }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Box flexGrow="1" bg="neutral.20" onClick={onClose} sx={{ opacity: 0.8 }} />
      <Flex
        flexDirection="column"
        bg="neutral.0"
        width={['100%', '100%', 'calc(100% - 40px)']}
        maxWidth="1100px"
        sx={{ position: 'relative', boxShadow: '-4px 0px 20px rgba(0, 0, 0, 0.08)', overflowY: 'auto' }}
      >
        {isFetching || !contact ? (
          <NotesDrawerLoader onClose={onClose} />
        ) : (
          <NotesDrawerContent contact={contact} onClose={onClose} />
        )}
      </Flex>
    </Flex>,
    document.getElementById('portals'),
  );
};

NotesDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  contactId: PropTypes.number,
  listInfo: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

NotesDrawer.defaultProps = {
  contactId: null,
  listInfo: null,
};
